module.exports = __webpack_public_path__ + "img/11.8c74cc5a.png";